import Button from '@mui/material/Button';
import { Icon } from '@shared/icons';
import type { TimeZone } from '@shared/utils/date';
import type { MouseEventHandler } from 'react';
import type { PopperTriggerProps } from '../../Popper';
import type { DateRange, LabeledPreset } from '../types';
import { ValueLabel } from './ValueLabel';

export type TriggerVariant = 'button' | 'icon';

export interface TriggerProps extends Omit<PopperTriggerProps, 'disabled'> {
  open: boolean;
  presets?: readonly LabeledPreset[];
  timeZone?: TimeZone;
  value: DateRange;
  variant?: TriggerVariant;
}

export function Trigger({
  onClick,
  presets,
  timeZone,
  value,
  variant = 'button',
}: TriggerProps) {
  if (variant === 'icon') {
    return (
      <Button
        color="inherit"
        onClick={onClick as MouseEventHandler<HTMLButtonElement>}
        size="large"
        variant="outlined"
      >
        <Icon name="calendar" size="small" />
      </Button>
    );
  }

  return (
    <Button
      color="inherit"
      onClick={onClick as MouseEventHandler<HTMLButtonElement>}
      size="medium"
      startIcon={<Icon name="calendar" size="small" />}
      variant="outlined"
      sx={{ maxWidth: '100%' }}
    >
      <ValueLabel value={value} presets={presets} timeZone={timeZone} />
    </Button>
  );
}
